<template>
  <b-modal
    v-model="visibleProxy"
    title="Error Summary"
    size="lg"
    ok-only
    ok-title="Close"
    scrollable
    footer-class="actuals-error-summary-modal-footer"
    @hidden="$emit('hidden')"
  >
    <div v-if="loading" class="text-center py-4">
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

    <div v-else-if="error" class="text-danger py-3">
      {{ error }}
    </div>

    <div v-else-if="summary.totals">
      <div class="aes-summary-bar">
        <span class="aes-chip aes-chip-error">{{ summary.totals.error }} errors</span>
        <span class="aes-chip aes-chip-success">{{ summary.totals.success }} success</span>
        <span class="aes-chip aes-chip-neutral">{{ summary.totals.unprocessed }} unprocessed</span>
        <span class="aes-chip aes-chip-neutral">{{ summary.totals.cancelled }} cancelled</span>
      </div>

      <div v-if="summary.totals.error === 0" class="aes-empty">
        <i class="fa fa-check-circle"></i>
        No actuals errors in this date range.
      </div>

      <div v-else>
        <div
          v-for="group in groupsWithCategories"
          :key="group.id"
          class="aes-group"
        >
          <div class="aes-group-header">
            {{ group.label }}
            <span class="aes-group-count">{{ group.bookings }} of {{ summary.totals.error }} errors</span>
          </div>

          <table class="aes-table">
            <thead>
              <tr>
                <th>Category</th>
                <th class="aes-col-count">Count</th>
                <th class="aes-col-pct">% of errors</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="cat in group.categories" :key="cat.id">
                <td>{{ cat.category }}</td>
                <td class="aes-col-count">{{ cat.occurrences }}</td>
                <td class="aes-col-pct">{{ cat.pct }}%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="troubleshooterLink" class="aes-troubleshooter-link">
        <b-button size="sm" variant="outline-danger" :to="troubleshooterLink">
          <i class="fa fa-exclamation-triangle" style="margin-right: 4px;"></i>
          Open full Troubleshoot Errors page
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'actuals_error_summary_modal',

  props: {
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    error: { type: String, default: '' },
    summary: { type: Object, default: () => ({}) },
    errorCategories: { type: Array, default: () => [] },
    errorGroups: { type: Array, default: () => [] },
    troubleshooterLink: { type: Object, default: null },
  },

  computed: {
    visibleProxy: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      },
    },
    groupsWithCategories() {
      const groupLabels = (this.summary && this.summary.group_labels) || {}
      const groupStats = {}
      ;(this.errorGroups || []).forEach(group => {
        groupStats[group.id] = group
      })
      const order = ['booking_data', 'telematics_matching', 'other']
      return order
        .map(groupId => {
          const categories = (this.errorCategories || []).filter(cat => cat.group === groupId)
          const stats = groupStats[groupId] || {}
          return {
            id: groupId,
            label: groupLabels[groupId] || groupId,
            categories,
            bookings: stats.bookings || 0,
          }
        })
        .filter(group => group.categories.length > 0)
    },
  },
}
</script>

<style scoped>
.aes-summary-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}
.aes-chip {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  border: 1px solid #ccc;
  font-size: 13px;
  font-weight: 600;
}
.aes-chip-error {
  background-color: #f8d7da;
  color: #721c24;
}
.aes-chip-success {
  background-color: #d4edda;
  color: #155724;
}
.aes-chip-neutral {
  background-color: #e2e3e5;
  color: #383d41;
}
.aes-empty {
  text-align: center;
  padding: 24px 12px;
  color: #155724;
  font-size: 16px;
}
.aes-empty .fa {
  margin-right: 6px;
}
.aes-group {
  margin-bottom: 18px;
}
.aes-group-header {
  font-size: 15px;
  font-weight: 700;
  border-bottom: 2px solid #888;
  margin-bottom: 8px;
  padding-bottom: 4px;
  text-align: left;
}
.aes-group-count {
  font-size: 13px;
  font-weight: normal;
  font-style: italic;
  margin-left: 8px;
  color: #555;
}
.aes-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.aes-table th,
.aes-table td {
  border: 1px solid #ddd;
  padding: 6px 8px;
  text-align: left;
}
.aes-table th {
  background-color: #f5f5f5;
}
.aes-col-count,
.aes-col-pct {
  width: 90px;
  text-align: right;
  white-space: nowrap;
}
.aes-troubleshooter-link {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #dee2e6;
  text-align: left;
}
</style>

<style>
.actuals-error-summary-modal-footer {
  border-top: none;
}
</style>
